export default __webpack_public_path__ + "static/video4-359ced1922224d86b069a37b2d1973a5.mp4";